import React, {FC, useEffect, useState} from 'react';
import {LocalizationProvider, TimePicker} from "@mui/x-date-pickers";
import {AdapterMoment} from "@mui/x-date-pickers/AdapterMoment";
import moment, {Moment} from "moment-timezone";
import "react-datepicker/dist/react-datepicker.css";
import {defaultTheme} from "../../../themes/main";

interface Props {
    label?: string,
    value: any,
    onChange: any;
    disabled?: boolean;
    minutesStep?: number;
}

const TimepickerMUI: FC<Props> = ({value, label = '', onChange, disabled = false, minutesStep = 1, ...props}) => {
    const [val, setVal] = useState<Moment | null>(moment().tz('UTC').set({"hour": 12, "minute": 0}));
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        if (value) setVal(value);
    }, [value]);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <TimePicker
                open={opened}
                onClose={() => setOpened(false)}
                onOpen={() => setOpened(true)}
                label={label}
                value={val}
                disabled={disabled}
                onChange={(newValue) => {
                    setVal(newValue);
                    onChange(newValue);
                }}
                minutesStep={minutesStep}
                slotProps={{
                    textField: {
                        size: 'small',
                        onClick: () => setOpened(true)
                    },
                    field: {
                      readOnly: true,
                    },
                    layout: {
                        sx: {
                            ul: {
                                // 'overflow-y': 'scroll',
                                'scrollbarWidth': 'thin',
                                'scrollbarColor': '#81b8c0 #f0f0f0',
                                '&::-webkit-scrollbar': {
                                    'width': '7px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    'background': '#f0f0f0',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    'backgroundColor': '#76AFB8',
                                }
                            },
                        },
                    }
                }}
                sx={{
                    "& .MuiOutlinedInput-input": {
                        height: '24px',
                        fontSize: 14,
                        fontWeight: 400,
                        color: '#677477',
                        backgroundColor: "white",
                    },
                    ".MuiOutlinedInput-input.Mui-disabled": {
                        backgroundColor: `${defaultTheme.disabledBackgroundColor} !important`,
                    },
                }}
                {...props}
            />
        </LocalizationProvider>
    );
};

export default TimepickerMUI;
